import * as axios from "axios";
import { readFromStorage } from "./storageApi";
import ShowNotification from "../components/common/Notification/ShowNotification";

const localToken = readFromStorage("accessToken");
let access_token = localToken ? localToken : null;

export let fileUrl = '';
let baseURL = '';

if (global.location.hostname === "localhost" || global.location.hostname === "127.0.0.1") {
    fileUrl = 'http://localhost:8000/';
    baseURL = fileUrl + "api/";
} else {
    fileUrl = process.env.REACT_APP_API_FILE_URL || 'https://api.semacademy.az/';
    baseURL = process.env.REACT_APP_API_URL || 'https://api.semacademy.az/api/';
}

const instance = axios.create({
    baseURL: baseURL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    }
});

// Time formatting utilitləri
export const TimeFormatChanger = (time) => {
    let changedTime = time.replace('T', ' ').replaceAll('-', '.').substring(0, 19);
    let date = changedTime.substring(0, 10);
    const [year, month, day] = date.split(".");
    let newDate = day + "." + month + "." + year;
    let timem = changedTime.substring(10, 19);
    return newDate + timem;
};

export const dateFormatToDb = (time) => {
    let [dayM, monthM, yearM] = time.split("-");
    return yearM + "-" + monthM + '-' + dayM;
};

export const dateFormatToSite = (time) => {
    let [yearM, monthM, dayM] = time.split("-");
    return dayM + "-" + monthM + '-' + yearM;
};

// API obyektləri
export const authAPI = {
    login(email, password) {
        return instance.post(`/login`, { email, password }).then(response => {
            if (response.status === 200) return response.data;
            else if (response.status === 401) ShowNotification("Credential Error", "Please check user data", "danger");
            else ShowNotification("Credential Error", response.message, "danger");
        }).catch(error => {
            if (error.response?.status === 401) ShowNotification("Credential Error", "Please check user data", "danger");
            else ShowNotification("Credential Error", error.message, "danger");
        });
    },
    register(name, email, password) {
        return instance.post(`/register`, { name, email, password }).then(response => {
            if (response.status === 200) return response.data;
        }).catch(error => {
            if (error.response?.status === 401) ShowNotification("Credential Error", "Please check user data", "danger");
            else ShowNotification("Credential Error", error.message, "danger");
        });
    },
    logout() {
        return instance.post(`/logout`).then(response => {
            if (response.status === 200) return response.data;
        }).catch(error => {
            if (error.response?.status === 401) ShowNotification("Credential Error", "Please check user data", "danger");
            else ShowNotification("Credential Error", error.message, "danger");
        });
    },
    user() {
        return instance.get(`/user`).then(response => {
            if (response.status === 200) return response.data;
        }).catch(error => {
            if (error.response?.status === 401) ShowNotification("Credential Error", "Please check user data", "danger");
            else ShowNotification("Credential Error", error.message, "danger");
        });
    }
};

export const productTypesAPI = {
    getProductTypes() {
        return instance.get(`/productTypes`).then(response => {
            if (response.status === 200) return response.data;
        }).catch(error => {
            if (error.response?.status === 401) ShowNotification("Credential Error", "Please check user data", "danger");
            else ShowNotification("Credential Error", error.message, "danger");
        });
    },
    addProductTypes({ name, status }) {
        return instance.post(`/productTypes`, { name, status }).then(response => {
            if (response.status === 201) return response;
        }).catch(error => {
            if (error.response?.status === 401) {
                ShowNotification("Credential Error", "Please check user data", "danger");
                return error;
            } else {
                ShowNotification("Get Error", error.message, "danger");
                return error.response;
            }
        });
    },
    editProductTypes({ id, name, status }) {
        return instance.put(`/productTypes/${id}`, { name, status }).then(response => {
            if (response.status === 200) return response;
        }).catch(error => {
            if (error.response?.status === 401) {
                ShowNotification("Credential Error", "Please check user data", "danger");
                return error;
            } else {
                ShowNotification("Edit Error", error.message, "danger");
                return error.response;
            }
        });
    },
    deleteProductType(id) {
        return instance.delete(`/productTypes/${id}`).then(response => {
            if (response.status === 200) return response;
        }).catch(error => {
            if (error.response?.status === 401) {
                ShowNotification("Credential Error", "Please check user data", "danger");
                return error;
            } else {
                ShowNotification("Delete Error", error.message, "danger");
                return error.response;
            }
        });
    }
};

export const blogsAPI = {
    getBlogs(page, size) {
        return instance.get(`/blogs/page=${page}/size=${size}`).then(response => {
            if (response.status === 200) return response.data;
        }).catch(error => {
            if (error.response?.status === 401) {
                ShowNotification("Credential Error", "Please check user data", "danger");
                return error;
            } else {
                ShowNotification("Upload Error", error.message, "danger");
                return error.response;
            }
        });
    },
    addBlog({ title, content, youtubeLink, imgUrl, status, product_type_id }) {
        return instance.post(`/blogs`, { title, content, youtubeLink, imgUrl, status, product_type_id }).then(response => {
            if (response.status === 201) return response;
        }).catch(error => {
            if (error.response?.status === 401) {
                ShowNotification("Credential Error", "Please check user data", "danger");
                return error;
            } else {
                ShowNotification("Upload Error", error.message, "danger");
                return error.response;
            }
        });
    },
    editBlog({ id, title, content, youtubeLink, imgUrl, status, product_type_id }) {
        return instance.put(`/blogs/${id}`, { title, content, youtubeLink, imgUrl, status, product_type_id }).then(response => {
            if (response.status === 200) return response;
        }).catch(error => {
            if (error.response?.status === 401) {
                ShowNotification("Credential Error", "Please check user data", "danger");
                return error;
            } else {
                ShowNotification("Upload Error", error.message, "danger");
                return error.response;
            }
        });
    },
    deleteBlog(id) {
        return instance.delete(`/blogs/${id}`).then(response => {
            if (response.status === 200) return response;
        }).catch(error => {
            if (error.response?.status === 401) {
                ShowNotification("Credential Error", "Please check user data", "danger");
                return error;
            } else {
                ShowNotification("Upload Error", error.message, "danger");
                return error.response;
            }
        });
    }
};

export const productsAPI = {
    // Admin siyahısı — bütün statuslar (silinmişlər də daxil)
    getProducts(page, size) {
        return instance.get(`admin/products/page=${page}/size=${size}`)
            .then(response => {
                if (response.status === 200) return response.data;
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    ShowNotification("Credential Error", "Please check user data", "danger");
                } else {
                    ShowNotification("Credential Error", error.message, "danger");
                }
            });
    },
    // Admin detalları — status filteri yoxdur, hər statusda məhsul gəlir
    getProductById(id) {
        return instance.get(`admin/product/${id}`)
            .then(response => {
                if (response.status === 200) return response.data;
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    ShowNotification("Credential Error", "Please check user data", "danger");
                } else if (error.response?.status === 404) {
                    ShowNotification("Error", "Məhsul tapılmadı", "danger");
                } else {
                    ShowNotification("Credential Error", error.message, "danger");
                }
            });
    },
    addProduct(product) {
        return instance.post(`/products`, { ...product })
            .then(response => {
                if (response.status === 201 || response.status === 200) return response;
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    ShowNotification("Credential Error", "Please check user data", "danger");
                } else {
                    ShowNotification("Credential Error", error.message, "danger");
                }
            });
    },
    editProduct({ productId, title, content, youtubeLink, imgUrl, status, productType, eventType, price, startDate, endDate }) {
        return instance.put(`/products/${productId}`, {
            title, content, youtubeLink, imgUrl, status, productType, eventType, price, startDate, endDate
        })
            .then(response => {
                if (response.status === 200) return response;
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    ShowNotification("Credential Error", "Please check user data", "danger");
                    return error;
                } else {
                    ShowNotification("Credential Error", error.message, "danger");
                    return error.response;
                }
            });
    },
    // Soft delete — məhsul DB-dən silinmir, status=0 olur
    deleteProduct(id) {
        return instance.delete(`/products/${id}`)
            .then(response => {
                if (response.status === 200) return response;
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    ShowNotification("Credential Error", "Please check user data", "danger");
                } else {
                    ShowNotification("Credential Error", error.message, "danger");
                    return error.response;
                }
            });
    }
};

export const salesAPI = {
    getSales(params = {}) {
        const cleanParams = Object.fromEntries(
            Object.entries(params).filter(([, v]) => v !== '' && v !== null && v !== undefined)
        );
        return instance.get(`/sales`, { params: cleanParams }).then(response => {
            if (response.status === 200) return response.data;
        }).catch(error => {
            if (error.response?.status === 401) ShowNotification("Credential Error", "Please check user data", "danger");
            else ShowNotification("Credential Error", error.message, "danger");
        });
    },
    addSales(fullName, email, profession, jobPosition, jobName, mobile, serialNumber, fin_code, paymentStatus, productType, productId, price, orderDate) {
        return instance.post(`/sales`, {
            fullName, email, profession, jobPosition, jobName, mobile, serialNumber, fin_code, paymentStatus, productType, productId, price, orderDate
        }).then(response => {
            if (response.status === 200) return response.data;
        }).catch(error => {
            if (error.response?.status === 401) ShowNotification("Credential Error", "Please check user data", "danger");
            else ShowNotification("Credential Error", error.message, "danger");
        });
    },
    editSales(id, fullName, email, profession, jobPosition, jobName, mobile, serialNumber, fin_code, paymentStatus, productType, productId, price, orderDate) {
        return instance.put(`/sales/${id}`, {
            fullName, email, profession, jobPosition, jobName, mobile, serialNumber, fin_code, paymentStatus, productType, productId, price, orderDate
        }).then(response => {
            if (response.status === 200) return response.data;
        }).catch(error => {
            if (error.response?.status === 401) ShowNotification("Credential Error", "Please check user data", "danger");
            else ShowNotification("Credential Error", error.message, "danger");
        });
    },
    deleteSales(id) {
        return instance.delete(`/sales/${id}`).then(response => {
            if (response.status === 200) return response.data;
        }).catch(error => {
            if (error.response?.status === 401) ShowNotification("Credential Error", "Please check user data", "danger");
            else ShowNotification("Credential Error", error.message, "danger");
        });
    },
    refreshStatus(id) {
        return instance.post(`/admin/sales/${id}/refresh-status`).then(response => {
            if (response.status === 200) return response.data;
        }).catch(error => {
            if (error.response?.status === 401) ShowNotification("Credential Error", "Please check user data", "danger");
            else if (error.response?.status === 404) ShowNotification("Xəta", "Satış tapılmadı", "danger");
            else if (error.response?.status === 422) ShowNotification("Xəta", "kapitalOrderId yoxdur", "danger");
            else if (error.response?.status === 502) ShowNotification("Xəta", "Bank cavab vermədi", "danger");
            else ShowNotification("Xəta", error.message, "danger");
        });
    },
    refreshPending(days = 7) {
        return instance.post(`/admin/sales/refresh-pending`, null, { params: { days } }).then(response => {
            if (response.status === 200) return response.data;
        }).catch(error => {
            if (error.response?.status === 401) ShowNotification("Credential Error", "Please check user data", "danger");
            else ShowNotification("Xəta", error.message, "danger");
        });
    },
    getSaleHistory(id) {
        return instance.get(`/admin/sale/${id}/history`).then(response => {
            if (response.status === 200) return response.data;
        }).catch(error => {
            if (error.response?.status === 401) ShowNotification("Credential Error", "Please check user data", "danger");
            else ShowNotification("Xəta", error.message, "danger");
        });
    }
};

export const usersAPI = {
    getUsers(page, size) {
        return instance.get(`admin/users/page=${page}/size=${size}`)
            .then(response => {
                if (response.status === 200) return response.data;
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    ShowNotification("Credential Error", "Please check user data", "danger");
                } else {
                    ShowNotification("Error", error.message, "danger");
                }
            });
    },
    getUserById(id) {
        return instance.get(`admin/user/${id}`)
            .then(response => {
                if (response.status === 200) return response.data;
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    ShowNotification("Credential Error", "Please check user data", "danger");
                } else if (error.response?.status === 404) {
                    ShowNotification("Error", "İstifadəçi tapılmadı", "danger");
                } else {
                    ShowNotification("Error", error.message, "danger");
                }
            });
    },
    addUser({ name, email, password, password_confirmation, role }) {
        return instance.post(`admin/users`, { name, email, password, password_confirmation, role })
            .then(response => {
                if (response.status === 201 || response.status === 200) return response;
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    ShowNotification("Credential Error", "Please check user data", "danger");
                } else if (error.response?.status === 422) {
                    ShowNotification("Validasiya xətası", error.response.data.message || "Məlumatlar düzgün deyil", "danger");
                } else {
                    ShowNotification("Error", error.message, "danger");
                }
                return error.response;
            });
    },
    editUser(id, { name, email, role }) {
        return instance.put(`admin/user/${id}`, { name, email, role })
            .then(response => {
                if (response.status === 200) return response;
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    ShowNotification("Credential Error", "Please check user data", "danger");
                } else if (error.response?.status === 422) {
                    ShowNotification("Validasiya xətası", error.response.data.message || "Məlumatlar düzgün deyil", "danger");
                } else {
                    ShowNotification("Error", error.message, "danger");
                }
                return error.response;
            });
    },
    changeUserPassword(id, password, password_confirmation) {
        return instance.put(`admin/user/${id}/password`, { password, password_confirmation })
            .then(response => {
                if (response.status === 200) return response;
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    ShowNotification("Credential Error", "Please check user data", "danger");
                } else if (error.response?.status === 422) {
                    ShowNotification("Validasiya xətası", error.response.data.message || "Şifrə düzgün deyil", "danger");
                } else {
                    ShowNotification("Error", error.message, "danger");
                }
                return error.response;
            });
    },
    deleteUser(id) {
        return instance.delete(`admin/user/${id}`)
            .then(response => {
                if (response.status === 200) return response;
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    ShowNotification("Credential Error", "Please check user data", "danger");
                } else if (error.response?.status === 422) {
                    ShowNotification("Xəta", error.response.data.message || "İstifadəçi silinə bilməz", "danger");
                } else {
                    ShowNotification("Error", error.message, "danger");
                }
                return error.response;
            });
    }
};

const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp', 'image/gif'];
const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

export const filesTo = {
    add(selectedFile, productType) {
        if (!selectedFile) {
            ShowNotification("Xəta", "Fayl seçilməyib", "danger");
            return Promise.resolve({ status: 400, data: { message: "Fayl seçilməyib" } });
        }
        if (!ALLOWED_IMAGE_TYPES.includes(selectedFile.type)) {
            ShowNotification("Xəta", "Yalnız jpeg, png, jpg, webp, gif formatları qəbul olunur", "danger");
            return Promise.resolve({ status: 422, data: { message: "Yanlış format" } });
        }
        if (selectedFile.size > MAX_FILE_SIZE) {
            ShowNotification("Xəta", "Faylın ölçüsü 5MB-dan çox ola bilməz", "danger");
            return Promise.resolve({ status: 422, data: { message: "Fayl çox böyükdür" } });
        }

        const fileData = new FormData();
        fileData.append('photo', selectedFile, selectedFile.name);

        return instance.post(`/files/${productType}`, fileData)
            .then(response => {
                if (response && response.status === 200) return response;
                else if (response && response.status === 402) {
                    ShowNotification("Error", `${response.data.error}`, "danger");
                    return response.data;
                }
            })
            .catch(error => {
                if (error.response && error.response.status === 500) {
                    ShowNotification("Upload Error 10", "Please check data type", "danger");
                    return error.response;
                } else if (error.response && error.response.status === 422) {
                    ShowNotification("Xəta", error.response.data.message, "danger");
                    return error.response;
                } else {
                    ShowNotification("Upload Error 11", error.response?.data?.error || "Network error", "danger");
                    return error.response;
                }
            });
    }
};

// export const buildingApi = {
//     getBuildings(page, size) {
//         let headers = { Authorization: `Bearer ${access_token}` };
//         return instance.get(`/admin/device/building?page=${page}&size=${size}`, { headers: headers })
//             .then(response => response.status === 200 && response.data)
//             .catch(error => { if (error != null) alert(error.message); });
//     },
//     addBuilding(name) {
//         let headers = { Authorization: `Bearer ${access_token}` };
//         return instance.post(`/admin/device/building`, { name }, { headers: headers }).then(response => response).catch(error => error);
//     },
//     updateBuilding(id, name, status) {
//         let headers = { Authorization: `Bearer ${access_token}` };
//         return instance.put(`/admin/device/building`, { id, name, status }, { headers: headers }).then(response => response).catch(error => error);
//     },
//     getByIdBuilding(buildingId) {
//         let headers = { Authorization: `Bearer ${access_token}` };
//         return instance.get(`/admin/device/building/?${buildingId}`, { headers: headers })
//             .then(response => response.status === 200 && response.data)
//             .catch(error => { if (error != null) alert(error.message); });
//     },
//     deleteBuilding(buildingId) {
//         let headers = { Authorization: `Bearer ${access_token}` };
//         return instance.delete(`/admin/device/building/${buildingId}`, { headers: headers }).then(response => response).catch(error => { if (error != null) alert(error.message); });
//     }
// };
//
// export const deviceGroupApi = {
//     getDeviceGroups(page, size) {
//         let headers = { Authorization: `Bearer ${access_token}` };
//         return instance.get(`/admin/device/location?page=${page}&size=${size}`, { headers: headers })
//             .then(response => response.status === 200 && response.data)
//             .catch(error => { if (error != null) alert(error.message); });
//     },
//     addDeviceGroup(name, building) {
//         let headers = { Authorization: `Bearer ${access_token}` };
//         return instance.post(`/admin/device/location`, { name, building }, { headers: headers }).then(response => response).catch(error => error);
//     },
//     updateDeviceGroup(building, id, name, status) {
//         let headers = { Authorization: `Bearer ${access_token}` };
//         return instance.put(`/admin/device/location`, { building, id, name, status }, { headers: headers }).then(response => response).catch(error => error);
//     },
//     getByIdDeviceGroup(buildingId) {
//         let headers = { Authorization: `Bearer ${access_token}` };
//         return instance.get(`/admin/device/building/?${buildingId}`, { headers: headers })
//             .then(response => response.status === 200 && response.data)
//             .catch(error => { if (error != null) alert(error.message); });
//     },
//     deleteDeviceGroup(locationId) {
//         let headers = { Authorization: `Bearer ${access_token}` };
//         return instance.delete(`/admin/device/location/${locationId}`, { headers: headers }).then(response => response).catch(error => { if (error != null) alert(error.message); });
//     }
// };
//
// export const deviceApi = {
//     getDevices(page, size) {
//         let headers = { Authorization: `Bearer ${access_token}` };
//         return instance.get(`/admin/device/device?page=${page}&size=${size}`, { headers: headers })
//             .then(response => response.status === 200 && response.data)
//             .catch(error => { if (error != null) alert(error.message); });
//     },
//     addDevice(device) {
//         let { ip, name, password, type, username, location } = device;
//         let headers = { Authorization: `Bearer ${access_token}` };
//         return instance.post(`/admin/device/device`, { ip, name, password, type, username, location }, { headers: headers }).then(response => response).catch(error => error);
//     },
//     updateDevice(device) {
//         let { id, ip, name, status, password, type, username, location } = device;
//         let headers = { Authorization: `Bearer ${access_token}` };
//         return instance.put(`/admin/device/device`, { id, ip, name, status, password, type, username, location }, { headers: headers }).then(response => response).catch(error => error);
//     },
//     getByIdDevice(deviceId) {
//         let headers = { Authorization: `Bearer ${access_token}` };
//         return instance.get(`/admin/device/device/?${deviceId}`, { headers: headers })
//             .then(response => response.status === 200 && response.data)
//             .catch(error => { if (error != null) alert(error.message); });
//     },
//     deleteDevice(deviceId) {
//         let headers = { Authorization: `Bearer ${access_token}` };
//         return instance.delete(`/admin/device/device/${deviceId}`, { headers: headers }).then(response => response).catch(error => { if (error != null) alert(error.message); });
//     }
// };
//
// export const userAppApi = {
//     getAllUsers(page, size) {
//         let headers = { Authorization: `Bearer ${access_token}` };
//         return instance.get(`/user?page=${page}&size=${size}`, { headers: headers })
//             .then(response => response.status === 200 && response.data)
//             .catch(error => { if (error != null) alert(error.message); });
//     },
//     addUser(userData) {
//         let headers = { Authorization: `Bearer ${access_token}` };
//         let { email, locationid, mobile, name, officename, password, role, surname, username } = userData;
//         return instance.post(`/login/register`, { email, locationid, mobile, name, officename, password, role, surname, username }, { headers: headers }).then(response => response).catch(error => error);
//     },
//     updateUser(userData) {
//         let headers = { Authorization: `Bearer ${access_token}` };
//         let { id, email, locationid, mobile, status, name, officename, role, surname, username } = userData;
//         return instance.put(`/user/${id}`, { id, email, status, locationid, mobile, name, officename, role, surname, username }, { headers: headers }).then(response => response).catch(error => error);
//     },
//     deleteUser(id) {
//         let headers = { Authorization: `Bearer ${access_token}` };
//         return instance.delete(`/user/${id}`, { headers: headers }).then(response => response).catch(error => { if (error != null) alert(error.message); });
//     }
// };
//
// export const clientApi = {
//     getQrUsers(page, size) {
//         let headers = { Authorization: `Bearer ${access_token}` };
//         return instance.get(`/qruser?page=${page}&size=${size}`, { headers: headers })
//             .then(response => response.status === 200 && response.data)
//             .catch(error => { if (error != null) alert(error.message); });
//     },
//     editQrUserTime(userId) {
//         let headers = { Authorization: `Bearer ${access_token}` };
//         return instance.put(`/qruser/${userId}`, {}, { headers: headers }).then(response => response).catch(error => error);
//     },
//     generateQr() {
//         let headers = { Authorization: `Bearer ${access_token}` };
//         return instance.get(`/qruser/qr`, { headers: headers }).then(response => response).catch(error => { if (error != null) alert(error.message); });
//     },
//     addUser(userData) {
//         let headers = { Authorization: `Bearer ${access_token}` };
//         let { cartid, passport, mobile, name, surname, tooffice, permissionDate } = userData;
//         return instance.post(`/qruser`, { cartid, passport, mobile, name, surname, tooffice, permissionDate }, { headers: headers }).then(response => response).catch(error => error);
//     },
//     updateUser(userData) {
//         let headers = { Authorization: `Bearer ${access_token}` };
//         let { id, cartid, passport, mobile, name, status, surname, tooffice, permissionDate } = userData;
//         return instance.put(`/qruser/edit/${id}`, { cartid, passport, mobile, status, name, surname, tooffice, permissionDate }, { headers: headers }).then(response => response).catch(error => error);
//     }
// };
